module.exports = __webpack_public_path__ + "img/h5_login_logo.6b82e885.png";